import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { v4 } from 'uuid'
import { Button } from '@/components/buttons/Button'

import { loadPlaybookBodyByCid } from '@/reducers/realtime/realtime.actions'

import Select from '../Select'
import { MultiSelect } from '../MultiSelect'
import { RequiredIndicator } from '../RequiredIndicator'

import './PlaybookItemSelector.css'

// TODO: Make this an actual instance of an AbstractForm component - it does not belong in the AbstractForm main setup.
export const PlaybookItemSelector = ({
  values,
  label,
  options,
  configPaths,
  playbooks,
  onItemAdded,
  readOnly,
  ...props
}) => {
  const dispatch = useDispatch()
  const { configPathsLoading } = useSelector((state) => state.realtimeNewAlertConfiguration)

  const itemOptions = [
    { value: 'checklist', label: 'Checklist' },
    { value: 'deck', label: 'Dynamic Prompt' },
    { value: 'classified_postcall', label: 'Post Call' },
    { value: 'notifications', label: 'Notifications' },
    { value: 'checklist-timing', label: 'Checklist - Timing Configured' },
  ]

  const [selectedPlaybook, setSelectedPlaybook] = useState()
  const [selectedPlaybookItem, setSelectedPlaybookItem] = useState()
  const [selectedPlaybookPaths, setSelectedPlaybookPaths] = useState([])

  useEffect(() => {
    if (selectedPlaybook?.value) {
      dispatch(loadPlaybookBodyByCid({ playbookCid: selectedPlaybook?.value }))
    }
  }, [selectedPlaybook])

  function constructPlaybookItemOptions() {
    return selectedPlaybook && selectedPlaybookItem
      ? configPaths[selectedPlaybook.value].paths.filter((item) => {
          switch (selectedPlaybookItem.value) {
            case 'checklist-timing':
              return item.type === 'checklist' && item.required_before
            case 'checklist':
              return item.type === selectedPlaybookItem.value && !item.required_before
            default:
              return item.type === selectedPlaybookItem.value
          }
        })
      : []
  }

  return (
    <div {...props} className={`${props.className} field`}>
      <div className="flex label-style">
        {label}
        {props.required && <RequiredIndicator />}
      </div>
      <div className="main-box">
        <div className="full-width" data-testid="playbook-selector">
          <label className="playbook-labels">Select Playbook</label>
          <Select
            loading={configPathsLoading}
            placeholder="Select Playbook"
            options={
              configPaths
                ? Object.keys(configPaths).map((configId) => {
                    return {
                      key: configId,
                      label: configPaths[configId].name,
                      value: configId,
                    }
                  })
                : []
            }
            value={selectedPlaybook}
            onChange={(item) => {
              setSelectedPlaybook(item)
              setSelectedPlaybookItem(null)
              setSelectedPlaybookPaths(null)
            }}
            isDisabled={readOnly}
            {...props}
          />
        </div>
        <div className="flex medium-gap mt full-width">
          <div className="type-dropdown" data-testid="playbook-item-selector">
            <label className="playbook-labels" htmlFor="playbook-item-selector">
              Select Item Type
            </label>
            <Select
              placeholder="Select Item Type"
              aria-labelledby="playbook-item-selector"
              options={itemOptions}
              value={selectedPlaybookItem}
              isDisabled={!selectedPlaybook || readOnly}
              onChange={(item) => {
                setSelectedPlaybookItem(item)
                setSelectedPlaybookPaths(null)
              }}
              {...props}
            />
          </div>
          <div className="item-dropdown" data-testid="playbook-path-selector">
            <label className="playbook-labels">Select Item(s)</label>
            <MultiSelect
              loading={configPathsLoading}
              placeholder="Select Playbook Items"
              isDisabled={!selectedPlaybookItem}
              value={selectedPlaybookPaths}
              options={constructPlaybookItemOptions()}
              onChange={(items) => {
                setSelectedPlaybookPaths(items)
              }}
              {...props}
            />
          </div>
        </div>
        <div className="playbook-add-button-div">
          <Button
            data-testid="add-playbook-item"
            type="button"
            disabled={!selectedPlaybookPaths?.length || readOnly}
            onClick={() => {
              if (onItemAdded) {
                const items = []

                for (const path of selectedPlaybookPaths) {
                  items.push({
                    playbook: selectedPlaybook,
                    item: selectedPlaybookItem,
                    path,
                    id: v4(),
                  })
                }

                onItemAdded(items)
              }

              // clear dropdowns
              setSelectedPlaybook(null)
              setSelectedPlaybookItem(null)
              setSelectedPlaybookPaths([])
            }}
            primary
            className="playbook-add-button"
          >
            Add Trigger Item(s)
          </Button>
        </div>
      </div>
    </div>
  )
}
